// Libraries
import Grid from '@mui/material/Grid';

// MUI
// Core
import FormValidator from '../../../../../../core/FormValidator';

// Common
import { AInputItem, ARadioButtonGroupInputValue, ARadioButtons } from '../../../../../../common/inputs';

// Interfaces
// Store
// API
// Feature
import { AnimalAnnouncementsListViewStrings } from '../../strings/AnimalAnnouncementsListViewStrings';
import { useTranslation } from 'react-i18next';
import { ResourceTextApplication } from '../../../../../../core/resources';

export interface IControlButtonsProps {
    handleSelectedAnimalAnnouncementTypeChange: (selectedAnimalAnnouncementType: string) => void;
    handleSelectedAnimalAnnouncementStatusChange: (selectedAnimalAnnouncementStatus: string) => void;
    selectedAnimalAnnouncementType: string;
    selectedAnimalAnnouncementStatus: string;
}

export default function ControlButtons(props: IControlButtonsProps) {
    const validator = new FormValidator();

    const { t } = useTranslation<ResourceTextApplication[]>([
        'AnelmaBovine',
    ]);

    const getStatusSelectValues: () => AInputItem<ARadioButtonGroupInputValue>[]
        = () => {
            return [
                getInputItem(t('AnelmaBovine:1225'), 'AL'),
                getInputItem(t('AnelmaBovine:1226'), ''),
            ] ;
        }

    const getInputItem: (text: string, val: string) => AInputItem<ARadioButtonGroupInputValue>
        = (text: string, val: string) => {
            return {
                text: text,
                value: val
            };
        };

    return (
        <Grid container spacing={0} sx={{paddingBottom: '20px'}}>
            <Grid size={{ xs: 3, sm: 3, md: 3, lg: 3 }}>
                <ARadioButtons
                    id={AnimalAnnouncementsListViewStrings.ControlButtonsRadioAnnouncementType}
                    parameterName={`AnelmaBovine:${AnimalAnnouncementsListViewStrings.AnimalAnnouncementListViewBtns}`}
                    onChange={(v) => props.handleSelectedAnimalAnnouncementTypeChange(String(v))}
                    validator={validator}
                    value={props.selectedAnimalAnnouncementType}
                    sortValues={'default'}
                    withoutContainer
                />
            </Grid>
            <Grid size={{ xs: 3, sm: 3, md: 3, lg: 3 }}>
                <ARadioButtons
                    id={AnimalAnnouncementsListViewStrings.ControlButtonsRadioAnnouncementStatus}
                    items={getStatusSelectValues()}
                    onChange={(v) => props.handleSelectedAnimalAnnouncementStatusChange(String(v))}
                    validator={validator}
                    value={props.selectedAnimalAnnouncementStatus}
                    sortValues={'default'}
                    withoutContainer
                />
            </Grid>
        </Grid>
    );
}
